<div class="container">
    <mat-card class="center mt-5 mb-5">
        <mat-card-title>
            <h2 class="mt-3 mb-4">
                Reset Password</h2>
        </mat-card-title>

        <mat-card-content>
            <form [formGroup]="resetForm" (ngSubmit)="resetPassword()">

                <mat-form-field appearance="outline" class="form-field col-md-offset mb-3" style="width:100%">
                    <mat-label>Enter New Password</mat-label>
                    <input matInput [type]="hideNew ? 'password' : 'text'" name="newPassword" formControlName="newPassword"
                        [ngClass]="{'is-invalid':submitted && forms.newPassword.errors}" required autofocus>
                    <mat-error *ngIf="submitted && forms.newPassword.errors" class="invalid-feedback">
                        <div *ngIf="forms.newPassword.errors.required">Password is required</div>
                        <div *ngIf="forms.newPassword.errors.minlength"></div>
                        <div class="error-text" *ngIf="resetForm.get('newPassword').hasError('passwordStrength')">
                            {{resetForm.get('newPassword').errors['passwordStrength']}}
                        </div>
                    </mat-error>
                    <button mat-icon-button matSuffix (click)="hideNew = !hideNew" type="button"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideNew">
                        <mat-icon>{{hideNew ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                </mat-form-field>

                <!-- <label for="password" class=" form-label">Confirm Password</label> -->
                <mat-form-field appearance="outline" class="form-field col-md-offset mb-3" style="width:100%">
                    <mat-label>Confirm Password</mat-label>
                    <input matInput [type]="hideConfirmNew ? 'password' : 'text'" name="confirmPassword"
                        formControlName="confirmPassword"
                        [ngClass]="{'is-invalid':submitted && forms.confirmPassword.errors}" required autofocus>
                    <mat-error *ngIf="submitted && forms.confirmPassword.errors" class="invalid-feedback">
                        <div *ngIf="forms.confirmPassword.errors.required">Password is required</div>
                        <div *ngIf="forms.confirmPassword.errors.minlength"></div>
                        <div class="error-text" *ngIf="resetForm.get('confirmPassword').hasError('passwordStrength')">
                            {{resetForm.get('confirmPassword').errors['passwordStrength']}}
                        </div>
                    </mat-error>
                    <button mat-icon-button matSuffix (click)="hideConfirmNew = !hideConfirmNew" type="button"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirmNew">
                        <mat-icon>{{hideConfirmNew ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                </mat-form-field>
                <alert></alert>
                <mat-card-actions>
                    <!-- <a href="" class="col-md-5" style = "text-decoration: none;">Forgot Password?</a> -->
                    <button type="submit" class="btn btn-primary d-grid w-100 "> Submit </button>

                    <button class="btn btn-primary d-grid w-100 mt-3 mb-3"
                        [routerLink]="'/signin'">Cancel</button>
                </mat-card-actions>
            </form>
        </mat-card-content>
    </mat-card>
</div>